// extracted by mini-css-extract-plugin
module.exports =  {"container":"OZfb77I2Zp16JfeQqpU8","bordered":"MaJpDFRU7zezNNqRkbEi"};